import { render, staticRenderFns } from "./NewOpportunityDialog.vue?vue&type=template&id=d16cfe20&scoped=true&"
import script from "./NewOpportunityDialog.vue?vue&type=script&lang=js&"
export * from "./NewOpportunityDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewOpportunityDialog.vue?vue&type=style&index=0&id=d16cfe20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16cfe20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
